<h3>
    {{leyenda}}
</h3>
<div class="progress mt10 mbn">
    <div class="progress-bar progress-bar-system progress-bar-striped active" role="progressbar" [attr.aria-valuenow]="progreso" aria-valuemin="0" aria-valuemax="100" [style.width]="progreso +'%'">
        <span class="sr-only">45% Complete</span>
    </div>


</div>
<div class="row mt5">
    <div class="col-md-2">
        <input type="text" class="form-control" [(ngModel)]="progreso">
    </div>
</div>
<div class="mt5">
    <button type="button" class="btn btn-primary mr5" (click)="cambiarValor(-5)">Menos</button>
    <button type="button" class="btn btn-primary" (click)="cambiarValor(5)">Mas</button>
</div>
